import AlbumInnerPageHeader from './AlbumInnerPageHeader';

export default AlbumInnerPageHeader;
